import { useCallback, useEffect } from 'react';
import { usePushEvents } from '../../hooks/PushEvents';
import {
    getAccessTokenFromLocalStorage,
    setLoginTypeLocalStorage,
} from './donorLocalStorage';
import {
    useDonorProfile,
    useGiftSummary,
    useRecurringDonations,
} from '../../api';

export const useLoadDonor = () => {
    const { addProfile, extendProfile } = usePushEvents();
    const { donorProfile, hasNeverFetched, refetch } = useDonorProfile();
    const {
        hasNeverFetched: giftSummaryHasNeverFetched,
        refetch: refetchGiftSummary,
    } = useGiftSummary();
    const {
        hasNeverFetched: recurringDonationsHasNeverFetched,
        refetch: refetchRecurringDonations,
    } = useRecurringDonations();

    const loadProfile = useCallback(
        (forcePull?: boolean) => {
            if (
                getAccessTokenFromLocalStorage() &&
                (forcePull || hasNeverFetched)
            ) {
                refetch();
            }
        },
        [hasNeverFetched, refetch],
    );

    useEffect(() => {
        if (hasNeverFetched) return;
        if (donorProfile) {
            const { id, name, email } = donorProfile.donor;
            setLoginTypeLocalStorage(name, email, undefined);
            addProfile({
                name,
                email,
                donor_id: id,
            });
            if (giftSummaryHasNeverFetched) {
                refetchGiftSummary().then((r) => {
                    if (!r.isSuccess) return;
                    extendProfile(r.data.all.count);
                });
            }
            if (recurringDonationsHasNeverFetched) {
                refetchRecurringDonations().then((r) => {
                    if (!r.isSuccess) return;
                    extendProfile(undefined, r.data.length > 0);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasNeverFetched, donorProfile]);

    return loadProfile;
};
